import { create } from 'zustand';

type TestStore = {
  number: number;
  location: string;
  random: number;
  increment: (number: number) => void;
  reset: () => void;
  setLocation: (location: string) => void;
  setRandom: (random: number) => void;
};

export const useTestStore = create<TestStore>()((set) => ({
  number: 2,
  location: 'VIC',
  random: 0,
  increment: () => {
    set((state) => ({ number: state.number + 1 }));
  },
  reset: () => {
    set({ number: 0 });
  },
  setLocation: (location: string) => {
    set({ location });
  },
  setRandom: (random: number) => {
    set({ random });
  },
}));
